import { motion } from "framer-motion";
import Reveal, { EASE } from "@/components/Reveal";

const STEPS = [
    {
        number: "01",
        title: "Ascolto",
        text: "Comprendiamo obiettivi, contesto e persone prima di ogni proposta.",
        testid: "metodo-step-ascolto",
    },
    {
        number: "02",
        title: "Analisi",
        text: "Leggiamo dati e organizzazione per individuare leve e priorità.",
        testid: "metodo-step-analisi",
    },
    {
        number: "03",
        title: "Strategia",
        text: "Tracciamo una rotta chiara con azioni concrete e misurabili.",
        testid: "metodo-step-strategia",
    },
    {
        number: "04",
        title: "Supporto",
        text: "Ti accompagniamo nell'esecuzione, adattando il percorso nel tempo.",
        testid: "metodo-step-supporto",
    },
];

export default function Metodo() {
    return (
        <section id="metodo" data-testid="metodo-section" className="bg-[#1A1A1A] py-24 text-[#FAF7F2] sm:py-32">
            <div className="mx-auto max-w-7xl px-5 sm:px-8">
                <div className="grid gap-10 lg:grid-cols-[1fr_1.6fr]">
                    <div className="lg:sticky lg:top-32 lg:self-start">
                        <Reveal>
                            <p className="text-xs font-medium uppercase tracking-[0.3em] text-[#D4A5A5]">
                                Il nostro metodo
                            </p>
                        </Reveal>
                        <Reveal delay={0.1}>
                            <h2 className="mt-4 font-serif text-4xl leading-tight tracking-tight sm:text-5xl">
                                Un percorso disegnato <span className="italic text-[#D4A5A5]">su di te</span>.
                            </h2>
                        </Reveal>
                        <Reveal delay={0.2}>
                            <p className="mt-6 max-w-md text-sm leading-relaxed text-[#FAF7F2]/60 sm:text-base">
                                Quattro passi, una sola direzione: il tuo obiettivo. Ogni percorso parte dall'ascolto e
                                arriva a risultati misurabili.
                            </p>
                        </Reveal>
                    </div>

                    <div>
                        {STEPS.map((s, i) => (
                            <Reveal key={s.number} delay={0.08 * i}>
                                <div
                                    data-testid={s.testid}
                                    className="group flex items-baseline gap-6 border-b border-[#FAF7F2]/10 py-10 transition-colors duration-500 first:border-t hover:border-[#D4A5A5]/40 sm:gap-10"
                                >
                                    <span className="text-outline-cream select-none font-serif text-5xl font-bold transition-all duration-500 group-hover:-translate-y-1 sm:text-7xl">
                                        {s.number}
                                    </span>
                                    <div>
                                        <h3 className="font-serif text-2xl transition-colors duration-300 group-hover:text-[#D4A5A5] sm:text-3xl">
                                            {s.title}
                                        </h3>
                                        <p className="mt-2 max-w-lg text-sm leading-relaxed text-[#FAF7F2]/60 sm:text-base">
                                            {s.text}
                                        </p>
                                    </div>
                                </div>
                            </Reveal>
                        ))}
                    </div>
                </div>

                <Reveal delay={0.1} className="mt-20">
                    <motion.div
                        whileHover={{ scale: 0.99 }}
                        transition={{ duration: 0.6, ease: EASE }}
                        className="overflow-hidden rounded-2xl"
                    >
                        <motion.img
                            initial={{ scale: 1.12 }}
                            whileInView={{ scale: 1 }}
                            viewport={{ once: true }}
                            transition={{ duration: 1.4, ease: EASE }}
                            src="https://images.unsplash.com/photo-1681949287382-052ea3954a51?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600"
                            alt="Il team GPS srls durante un workshop"
                            className="aspect-[21/9] w-full object-cover"
                            loading="lazy"
                        />
                    </motion.div>
                </Reveal>
            </div>
        </section>
    );
}
